module.exports = __webpack_public_path__ + "img/shop.90395544.svg";